import React from 'react'
import { Badge, } from 'reactstrap'

export default function SetItemsFilter (props) {
  return (
      <Badge 
        color='primary' 
        className='m2clickable mr-1 mb-1' 
        onClick={() => props.removeItemFilter(props.filterBy)}
      >
        <strong>{props.filterBy}:</strong> {props.filterText} <sup>x</sup>
      </Badge>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemsFilter.js